import request from "@/utils/request";

// 分页查询
export function queryDeployList(data) {
  return request({
    url: "/process/deploy/page",
    method: "post",
    params: data,
  });
}

// 删除
export function deleteDeploy(id) {
  return request({
    url: `/process/deploy/deleteDeploy/${id}`,
    method: "get",
  });
}
